(() => {
  const section = document.querySelector('[data-mh-section]');
  const reader = document.querySelector('[data-mh-reader]');
  if (!section || !reader) return;
  const previewTheme = window.Shopify && window.Shopify.theme;
  if (previewTheme && previewTheme.role === 'unpublished' && previewTheme.id) {
    document.addEventListener('submit', (event) => {
      if (!(event.target instanceof HTMLFormElement) || !event.target.matches('[data-nb-localization-form]')) return;
      const previewUrl = new URL(window.location.href);
      previewUrl.searchParams.set('preview_theme_id', String(previewTheme.id));
      window.history.replaceState(window.history.state, '', `${previewUrl.pathname}${previewUrl.search}${previewUrl.hash}`);
    }, true);
  }
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktopMotion = window.matchMedia('(min-width: 861px) and (hover: hover) and (pointer: fine)');
  const scrollArea = reader.querySelector('[data-mh-scroll]');
  const fullImage = reader.querySelector('[data-mh-full-src]');
  const avifSource = reader.querySelector('[data-mh-avif-fit-srcset]');
  const zoomButton = reader.querySelector('[data-mh-zoom]');
  let returnFocus = null;
  let sectionInView = false;
  let frame = 0;
  let scrollPosition = 0;
  let highResRequested = false;
  let motionListening = false;

  const setZoom = (zoomed) => {
    if (zoomed && !highResRequested) {
      if (avifSource) {
        avifSource.srcset = avifSource.dataset.mhAvifFullSrc;
        avifSource.removeAttribute('sizes');
      }
      fullImage.src = fullImage.dataset.mhFullSrc;
      fullImage.removeAttribute('srcset');
      highResRequested = true;
    }
    reader.classList.toggle('nb-mh-reader--zoomed', zoomed);
    zoomButton.setAttribute('aria-pressed', String(zoomed));
    zoomButton.querySelector('[data-mh-zoom-label]').textContent = zoomed
      ? zoomButton.dataset.fitLabel
      : zoomButton.dataset.zoomLabel;
    scrollArea.scrollLeft = 0;
    scrollArea.scrollTop = 0;
  };

  const sizeFitImage = () => {
    if (!reader.open || highResRequested) return;
    const padding = parseFloat(window.getComputedStyle(scrollArea).paddingLeft) * 2;
    const fitWidth = Math.max(1, Math.min(scrollArea.clientWidth - padding, 700, (window.innerHeight - 250) * 1800 / Number(fullImage.getAttribute('height') || 2398)));
    const sizes = `${Math.ceil(fitWidth)}px`;
    if (avifSource) {
      avifSource.sizes = sizes;
      avifSource.srcset = avifSource.dataset.mhAvifFitSrcset;
    }
    fullImage.sizes = sizes;
    fullImage.srcset = fullImage.dataset.mhFitSrcset;
    fullImage.src = fullImage.dataset.mhFitSrc;
  };

  const openReader = (trigger) => {
    if (reader.open) return;
    returnFocus = trigger;
    scrollPosition = window.scrollY;
    setZoom(false);
    reader.showModal();
    document.documentElement.classList.add('nb-mh-reader-open');
    sizeFitImage();
    window.addEventListener('resize', sizeFitImage, { passive: true });
    syncMotion();
    const header = reader.querySelector('[data-mh-close]');
    header.focus({ preventScroll: true });
  };

  const closeReader = () => {
    if (reader.open) reader.close();
  };

  document.querySelectorAll('[data-mh-open]').forEach((trigger) => {
    trigger.addEventListener('click', () => openReader(trigger));
  });
  reader.querySelector('[data-mh-close]').addEventListener('click', closeReader);
  zoomButton.addEventListener('click', () => {
    setZoom(!reader.classList.contains('nb-mh-reader--zoomed'));
  });
  reader.addEventListener('click', (event) => {
    if (event.target !== reader) return;
    const bounds = reader.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeReader();
  });
  reader.addEventListener('close', () => {
    window.removeEventListener('resize', sizeFitImage);
    document.documentElement.classList.remove('nb-mh-reader-open');
    window.scrollTo({ top: scrollPosition, behavior: 'instant' });
    if (returnFocus && document.contains(returnFocus)) returnFocus.focus({ preventScroll: true });
    syncMotion();
  });

  let cancelJump = () => {};
  const jumpToSection = (behavior = reducedMotion.matches ? 'auto' : 'smooth') => {
    cancelJump();
    let timeout = 0;
    let alignmentFrame = 0;
    let passes = 0;
    const finish = () => {
      window.clearTimeout(timeout);
      window.cancelAnimationFrame(alignmentFrame);
      document.removeEventListener('scrollend', settle);
      window.removeEventListener('pointerdown', finish);
      window.removeEventListener('wheel', finish);
      window.removeEventListener('keydown', finish);
    };
    const align = () => {
      if (reader.open) return finish();
      const offset = parseFloat(window.getComputedStyle(section).scrollMarginTop) || 0;
      const correction = section.getBoundingClientRect().top - offset;
      if (Math.abs(correction) > 1) window.scrollBy({ top: correction, behavior: 'instant' });
      if (++passes < 3) alignmentFrame = window.requestAnimationFrame(align);
      else finish();
    };
    const settle = () => {
      window.clearTimeout(timeout);
      document.removeEventListener('scrollend', settle);
      alignmentFrame = window.requestAnimationFrame(align);
    };
    cancelJump = finish;
    // Deferred sections can change height while the smooth jump is in progress.
    document.addEventListener('scrollend', settle, { once: true });
    window.addEventListener('pointerdown', finish, { once: true, passive: true });
    window.addEventListener('wheel', finish, { once: true, passive: true });
    window.addEventListener('keydown', finish, { once: true });
    timeout = window.setTimeout(settle, 1200);
    section.scrollIntoView({ behavior, block: 'start' });
  };

  const jumpFromHash = () => {
    if (window.location.hash === '#mens-health') jumpToSection('auto');
  };
  window.addEventListener('hashchange', jumpFromHash);
  if (window.location.hash === '#mens-health') {
    if (document.readyState === 'complete') jumpFromHash();
    else {
      const cancelInitialJump = () => {
        window.removeEventListener('load', initialJump);
        window.removeEventListener('pointerdown', cancelInitialJump);
        window.removeEventListener('wheel', cancelInitialJump);
        window.removeEventListener('keydown', cancelInitialJump);
      };
      const initialJump = () => {
        cancelInitialJump();
        jumpFromHash();
      };
      window.addEventListener('load', initialJump, { once: true });
      window.addEventListener('pointerdown', cancelInitialJump, { once: true, passive: true });
      window.addEventListener('wheel', cancelInitialJump, { once: true, passive: true });
      window.addEventListener('keydown', cancelInitialJump, { once: true });
    }
  }

  document.querySelectorAll('[data-mh-jump]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      jumpToSection();
    });
  });

  const updateMotion = () => {
    frame = 0;
    if (!motionListening) return;
    const rect = section.getBoundingClientRect();
    const progress = Math.max(0, Math.min(1, (window.innerHeight - rect.top) / (window.innerHeight + rect.height)));
    section.style.setProperty('--mh-scroll', progress.toFixed(3));
  };
  const scheduleMotion = () => {
    if (motionListening && !frame) frame = window.requestAnimationFrame(updateMotion);
  };
  const syncMotion = () => {
    const enabled = sectionInView && desktopMotion.matches && !reducedMotion.matches && !reader.open;
    if (enabled === motionListening) return;
    motionListening = enabled;
    if (enabled) {
      window.addEventListener('scroll', scheduleMotion, { passive: true });
      window.addEventListener('resize', scheduleMotion, { passive: true });
      scheduleMotion();
    } else {
      window.removeEventListener('scroll', scheduleMotion);
      window.removeEventListener('resize', scheduleMotion);
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
      section.style.removeProperty('--mh-scroll');
    }
  };
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      sectionInView = entry.isIntersecting;
      if (sectionInView) {
        section.classList.add('nb-mh--entered');
      }
      syncMotion();
    }
  }, { threshold: 0 });
  observer.observe(section);
  const pageObserver = new IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting)) {
      section.classList.add('nb-mh--page-entered');
      pageObserver.disconnect();
    }
  }, { threshold: 0.22 });
  pageObserver.observe(section.querySelector('.nb-mh__paper-stack'));
  // Keep the publication controls clear of the existing floating purchase bar.
  const visibleControls = new Set();
  const controlsObserver = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) visibleControls.add(entry.target);
      else visibleControls.delete(entry.target);
    }
    document.documentElement.classList.toggle('nb-mh-controls-visible', visibleControls.size > 0);
  }, { rootMargin: '-76px 0px 0px', threshold: 0 });
  section.querySelectorAll('.nb-mh__stage-tools, .nb-mh__details').forEach((controls) => {
    controlsObserver.observe(controls);
  });
  reducedMotion.addEventListener('change', syncMotion);
  desktopMotion.addEventListener('change', syncMotion);
})();
